<template>
  <div v-if="showLittleTag" ref="graficaBox">
    <q-card class="container-indicador shadow-1 cursor-pointer row" @click="openURL()">
      <div class="row containerHeader">
        <div class="title">
          {{ nameIndicadorShort }}
        <q-tooltip v-if="nameIndicador !== nameIndicadorShort" anchor="top start" self="top middle">
          <strong>{{nameIndicador}}</strong>
        </q-tooltip>
        </div>
        <div v-if="this.dataIndicador.tipo === 'Cualitativo'" class="col-12 divDato">
          {{ respuesta }}
        </div>
        <div v-if="this.dataIndicador.tipo === 'Cuantitativo'" class="col-12 row divDato">
          <div class="row col-12 divDatoUltimoValor">{{ ultimoValor }} {{ unidadMedida }}</div>
          <div class="row col-12 divUltimoValor"><span>
              Último valor: <span id="measuring-date"><b>{{ fechaUltimoValor | dateMonthYear | capitalize }}</b></span>
            </span></div>
        </div>

        <div
        v-if="chartData.length && variacionIndicador !== 'No hay valor'"
          class="measuring-container col-12 text-right">
          <span v-if="isNegativeNumber(variacionIndicador)" id="measuring-date">
            <q-icon name="arrow_drop_down" />
            Ha descendido
          </span>
          <span v-else id="measuring-date">
            <q-icon name="arrow_drop_up" />
            Ha aumentado
          </span>
          <span id="measuring-date">
            {{ parseFloat(variacionIndicador).toFixed(2) }} {{ unidadMedidaIndicador }} desde {{ fechaAnteriorIndicador
                | dateMonthYear | capitalize
            }}
          </span>
        </div>
      </div>
      <div v-if="this.dataIndicador.tipo === 'Cuantitativo' && chartData.length <= 1" class="row col-12 divObjetivoLegend">
        <span class="objetivoLegend"> <hr class="line" />Objetivo: {{ datoObjetivo }} {{ unidadMedida }} <span class="fechaObjetivoLegend"> para {{ fechaDatoObjetivo | dateMonthYear | capitalize }}</span></span>
      </div>
      <div v-if="chartData.length > 1" class="row text-center" style="width: 100%;">
        <div class="col-12">
          <LineChart
            :height="145"
            :chartData="chartData"
            :periodData="periodData"
            :datosObjetivo ="datosObjetivo !== null ? datosObjetivo : datosObjetivoLittleCard"
            :tipoRecomendado="tipoRecomendado"
            :recomendadoPor="recomendadoPorIndicador"
            :recomendado="recomendadoIndicador"
            :unidadMedida="unidadMedidaIndicador" />
        </div>
      </div>
    </q-card>
  </div>

  <div v-else class="container-indicador container-indicador-big">
    <div class="row containerHeader">
      <div class="col-3 title"></div>
      <div class=" measuring-container col-12 text-right">
        <div v-if="chartData.length > 0" class="col-12">
          <span class="measuring">
            <span v-if="valueIndicadorFiltered===null" id="measuring-big">{{ String(parseFloat(valueIndicador).toFixed(2)) }} </span>
            <span v-else id="measuring-big">{{ String(parseFloat(valueIndicadorComputedFiltered).toFixed(2)) }} </span>
          </span>
          <span id="measuring-unit-big">{{ this.datosObjetivo.unidadMedida }}</span>
        </div>
        <div class="col-12">
          <div v-if="fechaUltimaIndicadorFiltered===null" class="row col-12 divDatoUltimoValorBig"><span>
            Último valor: <span id="measuring-date-big"><b>{{ fechaUltimaIndicador | dateMonthYear | capitalize }}</b></span>
          </span></div>
          <div v-else class="row col-12 divDatoUltimoValorBig"><span>
            Último valor: <span id="measuring-date-big"><b>{{ fechaUltimaIndicadorComputedFiltered | dateMonthYear | capitalize }}</b></span>
          </span></div>
        </div>
        <div v-if="chartData.length > 0" class="col-12">
          <span v-if="variacionIndicadorFiltered!=='No hay valor' && variacionIndicador !=='No hay valor'">
            <span
              v-if="valueIndicadorComputedFiltered!==null? isNegativeNumber(variacionIndicadorFiltered) : isNegativeNumber(variacionIndicador)"
              id="measuring-date-big"
            >
              <q-icon class="q-icon-big" name="arrow_drop_down" />
              Ha descendido
            </span>
            <span v-else id="measuring-date-big">
              <q-icon class="q-icon-big" name="arrow_drop_up" />
              Ha aumentado
            </span>
          </span>
          <span v-if="variacionIndicadorFiltered===null && variacionIndicador !=='No hay valor' " id="measuring-date-big">
             {{ parseFloat(variacionIndicador).toFixed(2) }} {{ unidadMedidaIndicador }} desde {{ fechaAnteriorIndicador | dateMonthYear | capitalize }}
          </span>
          <span v-else-if="variacionIndicadorFiltered==='No hay valor' || variacionIndicador === 'No hay valor'" id="measuring-date-big">
            No hay variación
          </span>
          <span v-else id="measuring-date-big">
            {{ parseFloat(variacionIndicadorFiltered).toFixed(2) }} {{ unidadMedidaIndicador }} desde {{ fechaAnteriorIndicadorComputedFiltered | dateMonthYear | capitalize }}
          </span>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div v-if="chartData.length > 0" class="col-12">
        <LineChart
        :height="350"
        :chartData="chartFiltered.length>0 ? chartFiltered : chartData"
        :periodData="periodData"
        :unidadMedida="unidadMedidaIndicador"
        :datosObjetivo ="datosObjetivo"
        :tipoRecomendado="tipoRecomendado"
        :recomendadoPor="recomendadoPorIndicador"
        :recomendado="recomendadoIndicador"
        />
      </div>
      <div v-else class="noData col-12">NO HAY DATOS DISPONIBLES</div>
    </div>

    <DialogCreate
      v-model="showDialogFilter"
      labelSuccess="Cerrar"
      :showBottonCancel="false"
      dataCy="popUpFilter"
      @save="aceptar()"
    >
      <template slot="body">
        <div class="noData title-option text-center">
          No hay datos disponibles para el rango seleccionado
        </div>
      </template>
    </DialogCreate>
  </div>
</template>
<script>
import Formats from '../../shared/mixins/Formats';
import LineChart from '@/shared/charts/LineChart.vue';
import moment from 'moment';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';
import * as types from '@/storeModules/NGUD/types';

export default {
  components: {
    LineChart,
    DialogCreate
  },
  mixins: [Formats],
  props: {
    dataIndicador: Object,
    showLittleTag: {
      type: Boolean,
      default: () => false
    },
    datosObjetivo: {
      type: Object,
      default: () => null
    },
    tipo: String
  },
  data () {
    return {
      resizeoBserver: null,
      width: 0,
      nameIndicador: '',
      nameIndicadorShort: '',
      valueIndicador: null,
      unidadMedidaIndicador: '',
      fechaUltimaIndicador: '',
      fechaAnteriorIndicador: '',
      variacionIndicador: 'No hay valor',
      recomendadoPorIndicador: '',
      recomendadoIndicador: null,
      tipoRecomendado: null,
      chartData: [],
      chartFiltered: [],
      valueIndicadorFiltered: null,
      variacionIndicadorFiltered: null,
      fechaUltimaIndicadorFiltered: null,
      fechaAnteriorIndicadorFiltered: null,
      showDialogFilter: false,
      fechaIniFiltered: null,
      fechaFinFiltered: null,
      fechaInicioMunicipal: null,
      fechaFinMunicipal: null,
      datoObjetivo: null,
      fechaDatoObjetivo: null,
      unidadMedida: null,
      datosObjetivoLittleCard: {},
      periodData: 'month'
    };
  },
  created () {
    this.fillData();
    if (this.dataIndicador.hasOwnProperty('fechaInicio') && this.dataIndicador.hasOwnProperty('fechaFin')) {
      let dateInicioSimple = this.dataIndicador.fechaInicio.split('T');
      let dateFinSimple = this.dataIndicador.fechaFin.split('T');
      this.fechaInicioMunicipal = moment(dateInicioSimple[0]).format('YYYY/MM/DD');
      this.fechaFinMunicipal = moment(dateFinSimple[0]).format('YYYY/MM/DD');
    }
    this.unidadMedidaIndicador = this.dataIndicador.unidadMedida;
    this.changeDataPeriod();
  },
  watch: {
    dataIndicador () {
      this.fillData();
    }
  },
  computed: {
    valueIndicadorComputedFiltered () {
      return this.valueIndicadorFiltered;
    },
    variacionIndicadorComputedFiltered () {
      return this.variacionIndicadorFiltered;
    },
    fechaUltimaIndicadorComputedFiltered () {
      return this.fechaUltimaIndicadorFiltered;
    },
    fechaAnteriorIndicadorComputedFiltered () {
      return this.fechaAnteriorIndicadorFiltered;
    }
  },
  mounted () {
    if (this.showLittleTag) {
      this.resizeoBserver = new ResizeObserver(this.onResize);
      this.resizeoBserver.observe(this.$refs.graficaBox);
      this.changeWidth();
    }
    this.$eventHub.$on('filterRangeOfDates', (fechaInicial, fechaFinal) => {
      this.fechaIniFiltered = fechaInicial;
      this.fechaFinFiltered = fechaFinal;
      this.filterChart(fechaInicial, fechaFinal);
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('filterRangeOfDates');
    if (this.showLittleTag) {
      this.resizeoBserver.unobserve(this.$refs.graficaBox);
    }
  },
  methods: {
    changeDataPeriod () {
      if (this.dataIndicador.hasOwnProperty('datosPartidaYObjetivo')) {
        switch (this.dataIndicador.datosPartidaYObjetivo.periodicidad) {
          case 'Mensual':
            this.periodData = 'month';
            break;
          case 'Revisión Mensual':
            this.periodData = 'month';
            break;
          case 'Anual':
            this.periodData = 'year';
            break;
          case 'Revisión Anual':
            this.periodData = 'year';
            break;
          default:
            this.periodData = 'month';
            break;
        }
      }
    },
    onResize () {
      this.$emit('resize', this.$refs.graficaBox.offsetWidth);
      this.changeWidth();
    },
    changeWidth () {
      const screenWidth = this.$refs.graficaBox.clientWidth;
      this.width = screenWidth;
      this.nameIndicadorShort = this.assertMaxChars(this.nameIndicador);
    },
    fillData () {
      if (this.datosObjetivo !== null) {
        this.datoObjetivo = this.datosObjetivo.datoObjetivo;
        this.fechaDatoObjetivo = this.datosObjetivo.fechaDatoObjetivo;
        this.unidadMedida = this.datosObjetivo.unidadMedida;
      }
      // diferenciar modelo tarjeta pequeña de modelo detalle
      if (this.dataIndicador.hasOwnProperty('acciones')) {
        this.fillOptionalData();
      } else {
        this.fillOptionalDataLittleTag();
      }
    },
    filterChart (fechaInicial, fechaFinal) {
      let posInicial = this.filterDateIni(fechaInicial);
      let posFinal = this.filterDateFin(fechaFinal);
      if (posInicial !== -1 && posFinal !== -1 && posFinal >= posInicial) {
        this.fillChartFiltered(posInicial, posFinal);
      } else {
        this.showDialogFilter = true;
      }
    },
    filterDateIni (fechaInicial) {
      let posInicial = -1;
      for (let i = 0; i < this.chartData.length && posInicial === -1; i++) {
        let dateIniSimple = this.chartData[i].date.split('T');
        if ((moment(dateIniSimple[0]).format('YYYY/MM/DD')) >= fechaInicial) {
          posInicial = i;
        }
      }
      return posInicial;
    },
    filterDateFin (fechaFinal) {
      let posFinal = -1;
      for (let i = this.chartData.length - 1; i >= 0 && posFinal === -1; i--) {
        let dateFinSimple = this.chartData[i].date.split('T');
        if ((moment(dateFinSimple[0]).format('YYYY/MM/DD')) <= fechaFinal) {
          posFinal = i;
        }
      }
      return posFinal;
    },
    fillChartFiltered (posInicial, posFinal) {
      this.chartFiltered = [];
      for (let i = posInicial; i <= posFinal; i++) {
        this.chartFiltered.push(this.chartData[i]);
      }
      this.fillDataHeaderChart();
    },
    fillDataHeaderChart () {
      let lastvalue = this.chartFiltered[this.chartFiltered.length - 1].value;
      this.fechaUltimaIndicadorFiltered = this.chartFiltered[this.chartFiltered.length - 1].date;
      this.valueIndicadorFiltered = lastvalue;
      // depende de que haya mas de un valor
      if (this.chartFiltered.length > 1) {
        let penultimatevalue = this.chartFiltered[this.chartFiltered.length - 2].value;
        this.fechaAnteriorIndicadorFiltered = this.chartFiltered[this.chartFiltered.length - 2].date;
        this.variacionIndicadorFiltered = String(lastvalue - penultimatevalue);
      } else {
        this.variacionIndicadorFiltered = 'No hay valor';
      }
    },
    aceptar () {
      this.showDialogFilter = false;
    },
    fillOptionalDataLittleTag () {
      this.nameIndicador = this.dataIndicador.name;
      this.nameIndicadorShort = this.assertMaxChars(this.dataIndicador.name);
      this.respuesta = this.dataIndicador.respuesta === true ? 'Sí' : 'No';
      this.variacionIndicador = 'No hay valor';
      this.datoObjetivo = this.dataIndicador.datoObjetivo;
      this.fechaDatoObjetivo = this.dataIndicador.fechaDatoObjetivo;
      this.ultimoValor = this.dataIndicador.ultimoValor;
      this.fechaUltimoValor = this.dataIndicador.fechaUltimoValor;
      this.unidadMedida = this.dataIndicador.unidadMedida;
      this.datosObjetivoLittleCard = {
        datoObjetivo: this.datoObjetivo,
        fechaDatoObjetivo: this.fechaDatoObjetivo,
        unidadMedida: this.unidadMedida
      };

      this.chartData = this.dataIndicador.hasOwnProperty('datosGraficaMunicipal') ? this.dataIndicador.datosGraficaMunicipal.valoresGrafica : [];
      this.roundCharData2Decimals();
      if (this.dataIndicador.hasOwnProperty('datosGraficaMunicipal') && this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length > 1) {
        this.fillOptionalDataHistoryLittleTag();
      } else {
        this.variacionIndicador = 'No hay valor';
      }
    },
    fillOptionalDataHistoryLittleTag () {
      this.fechaAnteriorIndicador = this.dataIndicador.datosGraficaMunicipal.valoresGrafica[this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length - 2].date;
      this.variacionIndicador = this.dataIndicador.datosGraficaMunicipal.variacion;
    },
    fillOptionalData () {
      this.chartData = this.dataIndicador.datosGraficaMunicipal.valoresGrafica;
      this.roundCharData2Decimals();
      this.fechaUltimaIndicador = (this.dataIndicador.datosGraficaMunicipal.valoresGrafica[this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length - 1].date);
      this.valueIndicador = this.dataIndicador.datosGraficaMunicipal.ultimoValorDelHistorico;
      if (this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length > 1) {
        this.fillOptionalDataHistory();
      } else {
        this.variacionIndicador = 'No hay valor';
      }
    },
    isNegativeNumber (variation) {
      return variation < 0;
    },
    fillOptionalDataHistory () {
      this.fechaAnteriorIndicador = (this.dataIndicador.datosGraficaMunicipal.valoresGrafica[this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length - 2].date);
      this.variacionIndicador = this.dataIndicador.datosGraficaMunicipal.variacion;
    },
    openURL () {
      this.$store.commit(types.MUTATE_SET_LOOP_INDICATORS, {});
      this.$router.push({
        name: 'detalle_indicador_aue',
        params: this.$route.name === 'indices-tematicos'
          ? { idCiudadIndicadorAUE: this.dataIndicador.id, tipo: this.tipo, nameLink: 'Observatorio de indicadores', link: '/indices-tematicos' }
          : { idCiudadIndicadorAUE: this.dataIndicador.id, tipo: this.tipo, nameLink: 'Mi Agenda Urbana: Vista General', link: '/vista-general' }
      });
    },
    assertMaxChars (title) {
      let maxsize = this.calculateCountOfLettersLikeResolution();
      if (title.length >= maxsize) {
        return title.substring(0, maxsize) + '...';
      }
      return title;
    },
    calculateCountOfLettersLikeResolution () {
      let countLetters = this.width / 3.81;
      return countLetters;
    },
    roundCharData2Decimals () {
      for (let i = 0; i < this.chartData.length; i++) {
        this.chartData[i].value = parseFloat(this.chartData[i].value).toFixed(2);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container-indicador.shadow-1.cursor-pointer{
  padding: 25px 25px 25px 25px;
}
.noData{
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -1.13px;
  color: $seafoam-blue-hover;
}
.container-indicador-big {
  margin-bottom: 95px;
}
.container-indicador {
  background-color: #ffffff;
  height: 350px !important;

  .text-center{
    height: 70%;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .divDato{
    // height: 20%;
    display: flex;
    justify-content: right;
    margin-top: 5px;
    font-family: DINPro;
    font-size: 24px;
    color: #0093b2;
    font-weight: bold;
  }
  .divDatoUltimoValor {
    display: flex;
    margin-top: 5px;
    justify-content: right;
    font-weight: bold;
  }
  .divUltimoValor, .divDatoUltimoValorBig{
    display: flex;
    justify-content: right;
    font-family: DINPro;
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.4px;
    color: #454545;
  }
  .divDatoUltimoValorBig {
    font-size: 14px;
  }
  .divObjetivoLegend {
    display: flex;
    align-self: flex-end;
  }
  .objetivoLegend, .fechaObjetivoLegend{
    font-family: DINPro;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.48px;
  }
  .objetivoLegend {
    color: #37b0be;
    display: flex;
  }
  .fechaObjetivoLegend{
    color: #454545;
    margin-left: 5px;
  }

  .containerHeader {
    width: 100%;
    word-wrap: break-word;
    display: block;

    .title {
      font-family: DINPro;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.64px;
      color: #002f6c;
    }

    .measuring-container {
      font-family: DINPro;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      .measuring {
        font-size: 28px;
        font-weight: bold;
        letter-spacing: -1.13px;
        color: $seafoam-blue-hover;
        #measuring-big {
          font-size: 40px;
        }
      }
      #measuring-unit {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: -0.56px;
        color: $seafoam-blue-hover;
      }
      #measuring-unit-big {
        font-size: 20px;
        font-weight: bold;
        letter-spacing: -0.56px;
        color: $seafoam-blue-hover;
      }
      #measuring-date-big {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: -0.48px;
        color: #454545;
      }
      #measuring-date {
        font-size: 12px;
        font-weight: bold;
        letter-spacing: -0.48px;
        color: #454545;
      }
      .date-text{
        font-size: 12px;
        letter-spacing: -0.48px;
        color: #454545;
      }
    }
  }
  .q-icon{
    font-size: 1.5em;
  }
  .q-icon-big{
    font-size: 2.3em;
  }
  .line {
    height: 2px;
    width: 15px;
    background-color: #37b0be;
    border-style: none;
    margin-right: 10px;
    align-self: center;
  }
}
</style>
